import { IInputAccelerator } from 'components/shared/NumberFormatter/NumberFormatter.model';

export const amountDefaultAccelerators: readonly IInputAccelerator[] = [
  {
    key: 'k',
    transform: val => val * 1000,
  },
  {
    key: 'm',
    transform: val => val * 1000000,
  },
  {
    key: 'g',
    transform: val => val * 1000000000,
  },
  {
    key: 'b',
    transform: val => val * 1000000000,
  },
];
